"use client";

import type { Route } from "next";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import Link from "next/link";
import React from "react";

import ProfilePicture from "@/components/user/profile-picture";
import { MemberRead } from "@/TS/Interfaces/global_interfaces";

function Info({
  member,
  isMobile,
  hideWebsite = false,
  publicPage,
  onClick,
}: {
  member: MemberRead;
  isMobile?: boolean;
  hideWebsite?: boolean;
  publicPage?: boolean;
  onClick?: () => void;
}) {
  return (
    <div className="flex md:text-sm md:flex-row items-start h-fit flex-start md:items-center gap-6">
      <ProfilePicture
        isFounder={member.isFounding}
        size={75}
        mobileSize={60}
        src={
          !member.public && publicPage ? "" : member?.avatar?.urls?.avatar_md
        }
        alt={
          !member.public && publicPage
            ? "Membre privé"
            : `${member.firstName} ${member.lastName}`
        }
        className={onClick ? "" : "cursor-default"}
        firstName={member.firstName}
        lastName={member.lastName}
        withTooltip={true}
        onClick={onClick}
        hideAvatar={!member.public && publicPage}
        hideIcon={VisibilityOffOutlinedIcon}
      />
      <div className="flex flex-col content-center text-text-noir leading-5">
        <p onClick={onClick}>
          {!member.public && publicPage ? (
            <b>Membre privé</b>
          ) : (
            <b>
              {member.firstName}
              <span className="uppercase"> {member.lastName}</span>
            </b>
          )}
        </p>
        {isMobile && (
          <p className="uppercase">
            {!member.public && publicPage ? (
              <b></b>
            ) : (
              <b>{member.organization.brand}</b>
            )}
          </p>
        )}
        {!isMobile && (
          <>
            <p>{member.jobTitle}</p>
            <p className="uppercase">
              {!member.public && publicPage ? (
                <b></b>
              ) : (
                <b>{member.organization.brand ?? member.organization.name}</b>
              )}
            </p>
            <p>{member.organization.activity}</p>
            {member.organization.website && !hideWebsite && (
              <Link
                href={member.organization.website as Route}
                target="_blank"
                className="underline hover:font-bold"
              >
                Site web de l'entreprise
              </Link>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(Info);
